var baseUrl = "https://prescription.topfoxx.com/";
const addToCartForm = (formData) => {
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};
$(".custom-lense-number select").on("change", function () {
  var e_val = $(this).val();
  if ($(this).attr("data-title") == "pupillary-sph") {
    if (e_val >= parseFloat("58") && e_val <= parseFloat("63")) {
      setTimeout(function () {
        $(".update-desc").addClass("d-none");
      }, 500);
    } else {
      setTimeout(function () {
        $(".update-desc").removeClass("d-none");
      }, 500);
    }
  }
  var o_val = $(".right-sph").val();
  var n_val = $(".left-sph").val();
  console.debug(o_val);
  console.debug(n_val);
  if (o_val < parseInt("-3.25") || n_val < parseInt("-3.25")) {
    $(".add-blue-glasses").removeClass("d-none");
    $(".rx--lens-message").addClass("d-none");
  } else {
    $(".add-blue-glasses").addClass("d-none");
    $(".rx--lens-message").removeClass("d-none");
  }
  var f_val = $(this).val();
  "pupillary-sph" == $(this).attr("data-title") &&
    (f_val > parseInt("58")
      ? $(".update-desc.pd-info-kids").removeClass("d-none")
      : $(".update-desc.pd-info-kids").addClass("d-none"));
});
$("body").on("change", 'input[type="file"]', function (o) {
  if ((o.preventDefault(), "" != $(this).val())) {
    $(".file-progress").removeClass("d-none");
    var file_data = $("#fileUploads").prop("files")[0];
    var form_data = new FormData();
    form_data.append("file", file_data);

    $.ajax({
      url: baseUrl + "custom-file-upload",
      method: "POST",
      crossDomain: true,
      contentType: false,
      cache: false,
      enctype: "multipart/form-data",
      processData: false,
      data: form_data,
      success: function (data1) {
        console.log("working");
        $(".prescription-upload").val(data1.file_path);
        $(".file-progress").addClass("d-none");
        $(".file-block").addClass("upload-success");
        $(".prescription-method").val("Upload File");
      },
      error: function (xhr, j1, j2) {
        $(".file-progress").addClass("d-none");
        console.log(xhr);
        console.log(j1);
        console.log(j2);
        alert("ERROR");
      },
    });
  }
});
$("input[name=pre-upload]").on("change", function (o) {
  if ($(this).val() == "email") {
    $(".di-flex").addClass("d-none");
    $(".prescription-method").val("Email");
  }
  if ($(this).val() == "upload") {
    $(".di-flex").removeClass("d-none");
  }
});

//step 1
$("input[name=pre-type]").on("change", function (o) {
  $(".prescription-type").val($(this).val());
});
//step 2
$("input[name=pre-lens]").on("change", function (o) {
  if ($(this).val() == "uv-400") {
    $(".pre-step-3").removeClass("d-none");
  }
  if ($(this).val() == "anti-blue") {
    // $("input[name=lens-color]").prop("checked", false);
    // $(".pre-step-3").addClass("d-none");
    // $(".prescription-lence-color").val("");
    $(".prescription-lense-color-style").val("");
    // $(".lens-color.op-1").text("");
    // $(".lens-color.op-2").text("");
  }
  $(".prescription-material").val($(this).attr("data-val"));
  $(".prescription-lence-price").val($(this).attr("data-price"));
});

// $("input[name=lens-color]").on("change", function (o) {
//   if ($(this).attr("data-price") == "0") {
//     $(".lens-color.op-1").text(": " + $(this).val());
//     $(".lens-color.op-2").text("");
//     $(".prescription-lens-color").val($(this).val());
//     $(".prescription-lense-color-style").val("");
//   } else {
//     $(".lens-color.op-1").text("");
//     $(".lens-color.op-2").text(": " + $(this).val());
//     $(".prescription-lence-color").val("");
//     $(".prescription-lense-color-style").val($(this).val());
//   }
// });
//step 4
$("input[name=lens-type]").on("change", function (o) {
  $(".prescription-lence-thickness").val($(this).val());
});
$("input[name=pre-lens],input[name=lens-type]").on(
  "change",
  function (o) {
    updatePrice();
  }
);
// step 5
$(".right-sph,.right-cyl,.right-axis").on("change", function (o) {
  var odValue =
    $(".right-sph").val() +
    "," +
    $(".right-cyl").val() +
    "," +
    $(".right-axis").val();
  $(".prescription-od").val(odValue);
});
$(".left-sph,.left-cyl,.left-axis").on("change", function (o) {
  var osValue =
    $(".left-sph").val() +
    "," +
    $(".left-cyl").val() +
    "," +
    $(".left-axis").val();
  console.log(osValue);
  $(".prescription-os").val(osValue);
});
$("#pupillarydistance").on("change", function (o) {
  $(".prescription-pd").val($(this).val());
});
$("#pupillarydistance").on("change", function (o) {
  $(".prescription-pd").val($(this).val());
});
$("#pd-2").on("change", function (o) {
  $(".prescription-pd2").val($(this).val());
});
// 2 PD
$("#customCheckOption1").on("change", function (o) {
  if ($(this).is(":checked")) {
    $(".dist2").removeClass("d-none");
  } else {
    $(".dist2").addClass("d-none");
  }
  $("#customCheckOption2").prop("checked", false);
  $("#pd-2").val("0");
  $(".prescription-pd2").val("");
});
$("#customCheckOption2").on("change", function (o) {
  $("#customCheckOption1").prop("checked", false);
  $(".dist2").addClass("d-none");
  $("#pd-2").val("0");
  $(".prescription-pd2").val("");
  $("#pupillarydistance").val("0");
  $(".prescription-pd").val("");
});
$(".btn-cart-popup").click(function () {
  validateFields();
});
$(".btn-cart-submit").click(function () {
  finalSubmit();
  closePrescriptionPopup();
});
$(".prescription-popup .popup-close").click(function () {
  $(".prescription-popup").addClass("d-none");
  $("sticky-header,#gorgias-chat-container,#stamped-rewards-init").removeClass(
    "di-none"
  );
  $("body").removeClass("overflow-hidden");
});
function validateFields() {
  if (!$("input[name=pre-type]").is(":checked")) {
    alert("Please check your prescription type.");
    return;
  }
  if (!$("input[name=pre-lens]").is(":checked")) {
    alert("Please pick your lens.");
    return;
  }
  // if ($("input[name=pre-lens]:checked").val() != "anti-blue") {
  //   if (!$("input[name=lens-color]").is(":checked")) {
  //     alert("Please choose your lens Color.");
  //     return;
  //   }
  // }
  if (!$("input[name=lens-type]").is(":checked")) {
    alert("Please choose your lens type.");
    return;
  }
  if (!$("input[name=pre-upload]").is(":checked")) {
    alert("Please upload your prescription.");
    return;
  }
  openPrescriptionPopup();
  updatePopupData();
}
function preGetForm() {
  let formData = {
    items: [],
  };
  getProductsIds().forEach((item) => {
    formData.items.push({
      id: item,
      quantity: 1,
      properties: {
        type: "prescription",
      },
    });
  });
  return formData;
}
function getProductsIds() {
  var productsIds = [];
  //sunglassess
  productsIds.push($("input[name=pre-lens]:checked").attr("data-variantId"));
  //color

  // if ($("input[name=pre-lens]:checked").val() != "anti-blue") {
  //   var lensColor = $("input[name=lens-color]:checked").attr("data-variantId");
  //   if (lensColor != undefined) {
  //     productsIds.push(lensColor);
  //   }
  // }
  //thickness
  var thickness = $("input[name=lens-type]:checked").attr("data-variantId");
  if (thickness != undefined) {
    productsIds.push(thickness);
  }
  return productsIds;
}
function updatePopupData() {
  $("td.right-sph").text($(".right-sph").val());
  $("td.right-cyl").text($(".right-cyl").val());
  $("td.right-axis").text($(".right-axis").val());
  $("td.left-sph").text($(".left-sph").val());
  $("td.left-cyl").text($(".left-cyl").val());
  $("td.left-axis").text($(".left-axis").val());
  //
  $(".product-upgrades-lens ul").html(
    '<li class="upgrade-item upgrade-type"><span class="upgrade-title" >Type:</span>Single Vision</li>' +
      '<li class="upgrade-item upgrade-material"><span class="upgrade-title">Material:</span>' +
      $("input[name=pre-type]:checked").val() +
      "</li>" +
      '<li class="upgrade-item upgrade-material"><span class="upgrade-title">Thickness:</span>' +
      $("input[name=lens-type]:checked").val() +
      "</li>" +
      '<li class="upgrade-item upgrade-material"><span class="upgrade-title">Lens:</span>' +
      $("input[name=pre-lens]:checked").attr("data-val") +
      "</li>"
  );
  if ($("input[name=pre-lens]:checked").val() != "anti-blue") {
    var colorType = "Lens Color:</span> ";
    // if ($("input[name=lens-color]:checked").attr("data-price") == "0") {
    //   colorType = "NON-Mirrored Lens Color:</span> ";
    // }
    var lensColor = $("#pre-lens-color").val();
    $(".prescription-lens-color").val(lensColor);
    $(".product-upgrades-lens ul").append(
      '<li class="upgrade-item upgrade-material"><span class="upgrade-title">' +
        colorType +
        lensColor+
        "</li>"
    );
  }
}
function openPrescriptionPopup() {
  $(".prescription-popup").removeClass("d-none");
  $("sticky-header,#gorgias-chat-container,#stamped-rewards-init").addClass(
    "di-none"
  );
  $("body").addClass("overflow-hidden");
}
function closePrescriptionPopup() {
  $(".prescription-popup").addClass("d-none");
  $("sticky-header,#gorgias-chat-container,#stamped-rewards-init").removeClass(
    "di-none"
  );
  $("body").removeClass("overflow-hidden");
}
function addAllProductsToCart() {
  jQuery.post(
    window.Shopify.routes.root + "cart/add.js",
    $("#prescription-form").serialize(),
    function (res) {
      addToCartForm(preGetForm());
    }
  );
}

function varentsToRemove(items) {
  let updates = {};
  items.forEach((item)=>{
    if(item.properties['type'] != null || item.properties['Group ID'] != null){
      updates[item.variant_id] = 0;
    }else{
      console.debug(item);
    }
  })
  return updates;
}

function finalSubmit() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    cache: false,
    dataType: "json",
    success: function (cart) {
      if (cart.items.length != 0) {
        // remove all products from cart
        jQuery.post(
          window.Shopify.routes.root + "cart/update.js",
          {
            updates: varentsToRemove(cart.items),
          },
          function (result) {
            addAllProductsToCart();
          }
        );
      } else {
        addAllProductsToCart();
      }
    },
  });
}
function updatePrice() {
  var productPrice = parseInt(
    $(".prescription-popup .product-price").attr("data-price")
  );
  var preLens = $("input[name=pre-lens]:checked").attr("data-price");
  // var lensColor = $("input[name=lens-color]:checked").attr("data-price");
  var lensType = $("input[name=lens-type]:checked").attr("data-price");

  if (preLens != undefined) {
    productPrice += parseInt(preLens);
  }
  // if (lensColor != undefined) productPrice += parseInt(lensColor);
  if (lensType != undefined) productPrice += parseInt(lensType);
  $(".prescription-total-price").val(productPrice);
  $(".final-price,.prescription-popup .product-price").text(
    "$" + productPrice + ".00"
  );
  $(".final-cost").removeClass("d-none");
}

